import Iframe from "react-iframe";
const PdfPreviewIframe = ({ pdfUrl, onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1050,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          maxHeight: "80vh",
          backgroundColor: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "10px 15px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h5 className="modal-title mb-0">Preview</h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
          ></button>
        </div>
        <div style={{ height: "90vh", padding: 0 }}>
          <Iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            title="PDF Preview"
            style={{
              border: "none",
              display: "block",
              width: "100%",
              height: "100%",
            }}
            frameBorder="0"
          ></Iframe>
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewIframe;
